import React from 'react';
import { Button } from '../ui/Button';
export function FinalCTASection() {
  return <section id="cta" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-84" data-mp="11n0e4fz5c2ia">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-85" data-mp="1gkaw886ao6mz"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-86" data-mp="1bjmvgus9kbfk"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-87" data-mp="1klmic3pym9qf">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight" data-id="element-88" data-mp="1kjs2v4xgj9tq">
          Ready to Stop Leaving Money on the Table?
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-89" data-mp="1uch4z974bbce">
          If you have a proven offer and an audience, but your sales don't
          reflect your potential, let's fix that.
        </p>

        <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 mb-10 inline-block text-left max-w-lg w-full" data-id="element-90" data-mp="24awx9fhvsqnh">
          <h3 className="text-white font-semibold mb-4 text-center" data-id="element-91" data-mp="1lojwke2eg453">
            Who this is for:
          </h3>
          <ul className="space-y-3" data-id="element-92" data-mp="1qnwjszx6nd87">
            <li className="flex items-start text-slate-300" data-id="element-93" data-mp="1qmv6spwlwgnu">
              <span className="text-emerald-400 mr-2" data-id="element-94" data-mp="1vn92d8h0ty4z">✓</span>
              Coaches & Course Creators ready to upscale
            </li>
            <li className="flex items-start text-slate-300" data-id="element-95" data-mp="20l16d0uxxapj">
              <span className="text-emerald-400 mr-2" data-id="element-96" data-mp="24n5u5iypjd49">✓</span>
              Business owners ready to invest in superior positioning
            </li>
            <li className="flex items-start text-slate-300" data-id="element-97" data-mp="29env470qddp8">
              <span className="text-emerald-400 mr-2" data-id="element-98" data-mp="2edh17edou2fd">✓</span>
              Creators who want to scale without being "salesy"
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center" data-id="element-99" data-mp="2obeonznq3v6x">
          <Button size="lg" variant="secondary" className="w-full sm:w-auto text-lg px-12 py-4" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).Calendly) {
            ;
            (window as any).Calendly.initPopupWidget({
              url: 'https://calendly.com/okechcopy/new-meeting'
            });
          }
        }} data-id="element-100" data-mp="2oc6ltewyy0zb">
            Book Your Strategy Call
          </Button>
          <p className="mt-4 text-sm text-slate-500" data-id="element-101" data-mp="2hcpo2ui0o9t3">
            Only 1 strategy spots left for Q4
          </p>
        </div>
      </div>
    </section>;
}